// Vendor libraries
import { EventEmitter } from '@angular/core';
// Components
import { MultiSelectListComponent } from 'SecurityListsApp/ts/features/security-list-selector-modals/components/multi-select-list/multi-select-list.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/pipes/index-of/index-of.pipe";
import * as i4 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-level-multi-select-list/pipes/is-multi-select-list-item-levels-selected.pipe";
import * as i5 from "SecurityListsApp/ts/features/security-list-selector-modals/components/multi-level-multi-select-list/pipes/is-multi-select-sub-list-item-levels-selected.pipe";
const _c0 = a0 => ({ "bg-yc-blue-90": a0 });
const _c1 = a0 => ({ show: a0 });
const _c2 = a0 => ({ collapse: a0 });
function MultiLevelMultiSelectListComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiLevelMultiSelectListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵlistener("click", function MultiLevelMultiSelectListComponent_div_0_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectItem(ctx_r1.parentItem)); });
    i0.ɵɵelementStart(2, "div", 4)(3, "span", 5);
    i0.ɵɵtext(4, "Select All");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MultiLevelMultiSelectListComponent_div_0_div_5_Template, 3, 1, "div", 6);
    i0.ɵɵpipe(6, "isMultiSelectListItemLevelsSelected");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(6, 1, ctx_r1.parentItem, ctx_r1.selectedItems, ctx_r1.activeSecurityGroupTab));
} }
function MultiLevelMultiSelectListComponent_div_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
} }
function MultiLevelMultiSelectListComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵlistener("click", function MultiLevelMultiSelectListComponent_div_1_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r3); const item_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectItem(item_r4)); });
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵelement(2, "span", 15);
    i0.ɵɵtemplate(3, MultiLevelMultiSelectListComponent_div_1_div_1_div_3_Template, 3, 1, "div", 6);
    i0.ɵɵpipe(4, "isMultiSelectListItemLevelsSelected");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", item_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", item_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind3(4, 3, item_r4, ctx_r1.selectedItems, ctx_r1.activeSecurityGroupTab));
} }
function MultiLevelMultiSelectListComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵpipe(1, "isMultiSelectSubListLevelsItemSelected");
    i0.ɵɵlistener("click", function MultiLevelMultiSelectListComponent_div_1_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const item_r4 = i0.ɵɵnextContext().$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openItem(item_r4)); });
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelement(3, "div", 18);
    i0.ɵɵpipe(4, "indexOf");
    i0.ɵɵelementStart(5, "span", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, i0.ɵɵpipeBind3(1, 3, item_r4, ctx_r1.selectedItems, ctx_r1.activeSecurityGroupTab)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, i0.ɵɵpipeBind2(4, 7, ctx_r1.openListItems, item_r4) > -1));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r4.name);
} }
function MultiLevelMultiSelectListComponent_div_1_ycn_multi_level_multi_select_list_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-multi-level-multi-select-list", 20);
    i0.ɵɵpipe(1, "indexOf");
    i0.ɵɵlistener("selectItemHandler", function MultiLevelMultiSelectListComponent_div_1_ycn_multi_level_multi_select_list_3_Template_ycn_multi_level_multi_select_list_selectItemHandler_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.selectItemChildren($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("level-", (ctx_r1.level + 1).toString(), "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c2, i0.ɵɵpipeBind2(1, 9, ctx_r1.openListItems, item_r4) === -1))("parentItem", item_r4)("listItems", item_r4.sub_list)("selectedItems", ctx_r1.selectedItems)("activeSecurityGroupTab", ctx_r1.activeSecurityGroupTab)("level", ctx_r1.level + 1);
} }
function MultiLevelMultiSelectListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiLevelMultiSelectListComponent_div_1_div_1_Template, 5, 7, "div", 10)(2, MultiLevelMultiSelectListComponent_div_1_div_2_Template, 7, 14, "div", 11)(3, MultiLevelMultiSelectListComponent_div_1_ycn_multi_level_multi_select_list_3_Template, 2, 14, "ycn-multi-level-multi-select-list", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r4.sub_list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.sub_list);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r4.sub_list && item_r4.sub_list.length > 0);
} }
export class MultiLevelMultiSelectListComponent extends MultiSelectListComponent {
    constructor() {
        super(...arguments);
        this.level = 0;
        this.selectAllItemsHandler = new EventEmitter();
    }
    selectItemChildren(item) {
        this.selectItemHandler.emit({ item: item.item, group: this.activeSecurityGroupTab });
    }
}
MultiLevelMultiSelectListComponent.ɵfac = /*@__PURE__*/ (() => { let ɵMultiLevelMultiSelectListComponent_BaseFactory; return function MultiLevelMultiSelectListComponent_Factory(__ngFactoryType__) { return (ɵMultiLevelMultiSelectListComponent_BaseFactory || (ɵMultiLevelMultiSelectListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultiLevelMultiSelectListComponent)))(__ngFactoryType__ || MultiLevelMultiSelectListComponent); }; })();
MultiLevelMultiSelectListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiLevelMultiSelectListComponent, selectors: [["ycn-multi-level-multi-select-list"]], inputs: { parentItem: "parentItem", level: "level" }, outputs: { selectAllItemsHandler: "selectAllItemsHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "linked-list-item", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "linked-list-item"], [1, "linked-list-item-header", "file-td-name", "td", 3, "click"], [1, "linked-list-item-header-wrap"], [1, "file-title"], ["class", "linked-list-item-controls", 4, "ngIf"], [1, "linked-list-item-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-check"], ["ycnIcon", "", 3, "name"], ["class", "linked-list-item parent border-bottom-0", 3, "click", 4, "ngIf"], ["class", "linked-list-collapse file-td-name border-bottom-0 td", 3, "ngClass", "click", 4, "ngIf"], [3, "class", "ngClass", "parentItem", "listItems", "selectedItems", "activeSecurityGroupTab", "level", "selectItemHandler", 4, "ngIf"], [1, "linked-list-item", "parent", "border-bottom-0", 3, "click"], [1, "file-td-name", "linked-list-item-header", "td", 3, "id"], [1, "text-gray-10", 3, "textContent"], [1, "linked-list-collapse", "file-td-name", "border-bottom-0", "td", 3, "click", "ngClass"], [1, "file-name"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "collapse-toggler", 3, "ngClass"], [1, "text-normal"], [3, "selectItemHandler", "ngClass", "parentItem", "listItems", "selectedItems", "activeSecurityGroupTab", "level"]], template: function MultiLevelMultiSelectListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MultiLevelMultiSelectListComponent_div_0_Template, 7, 5, "div", 0)(1, MultiLevelMultiSelectListComponent_div_1_Template, 4, 3, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.level > 0 && ctx.parentItem);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.listItems);
    } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.IconDirective, MultiLevelMultiSelectListComponent, i3.IndexOfPipe, i4.isMultiSelectListItemLevelsSelectedPipe, i5.isMultiSelectSubListItemLevelsSelectedPipe], encapsulation: 2 });
